// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
// import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { SvgIcon, SvgIconProps } from '@mui/material';

type SearchIconProps = SvgIconProps

const SearchIcon: React.FC<SearchIconProps> = (props) => {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" {...props}>
      <g strokeMiterlimit="10"> 
      <path 
        d="M6.9,12.3c-0.4,0-0.7,0-1.1-0.1c-1.1-0.2-2-0.7-2.8-1.5S1.8,9,1.6,8C1.4,6.9,1.5,5.8,1.9,4.8
          c0.4-1,1.1-1.8,2-2.4C6,1,9,1.3,10.7,3.1c1,1,1.6,2.4,1.6,3.8c0,1.1-0.3,2.1-0.9,3c-0.6,0.9-1.4,1.6-2.4,2
          C8.3,12.2,7.6,12.3,6.9,12.3z M6.9,2.5C6,2.5,5.2,2.8,4.5,3.2c-0.7,0.5-1.3,1.2-1.6,2S2.4,6.9,2.6,7.8C2.8,8.6,3.2,9.4,3.8,10
          c0.6,0.6,1.4,1,2.3,1.2c0.9,0.2,1.7,0.1,2.5-0.3c0.8-0.3,1.5-0.9,2-1.6c0.5-0.7,0.7-1.6,0.7-2.4c0-1.2-0.5-2.3-1.3-3.1
          C9.2,3,8.1,2.5,6.9,2.5z" 
      />
      <path 
        d="M14,14.5c-0.1,0-0.3,0-0.4-0.1l-3.4-3.4c-0.2-0.2-0.2-0.5,0-0.7s0.5-0.2,0.7,0l3.4,3.4c0.2,0.2,0.2,0.5,0,0.7
        C14.3,14.5,14.1,14.5,14,14.5z" 
      />
      </g>
    </SvgIcon>
  );
};

export default SearchIcon;